import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowDown, ArrowBigLeft } from 'lucide-react';

interface AgendaWizardProps {
  onDateClick: () => void;
  isVisible: boolean;
  targetDate: Date;
}

const AgendaWizard: React.FC<AgendaWizardProps> = ({
  onDateClick,
  isVisible,
  targetDate
}) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    if (isVisible) {
      const formattedDate = targetDate.getDate().toString();
      const dateElements = document.querySelectorAll('.fc-daygrid-day-number');

      let targetElement: Element | null = null;

      dateElements.forEach(element => {
        if (element.textContent?.trim() === formattedDate) {
          const parentCell = element.closest('.fc-daygrid-day');
          if (parentCell) {
            targetElement = parentCell;
          }
        }
      });

      if (!targetElement) {
        const timeGridCells = document.querySelectorAll('.fc-timegrid-day');
        const dayOfWeek = targetDate.getDay();

        if (timeGridCells && timeGridCells.length > 0) {
          const targetIndex = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
          if (targetIndex >= 0 && targetIndex < timeGridCells.length) {
            targetElement = timeGridCells[targetIndex];
          }
        }
      }

      if (targetElement) {
        const rect = targetElement.getBoundingClientRect();
        setPosition({
          x: rect.left + rect.width / 2,
          y: rect.top - 70
        });

        targetElement.classList.add('wizard-target-highlight');

        return () => {
          targetElement?.classList.remove('wizard-target-highlight');
        };
      }
    }
  }, [isVisible, targetDate]);

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 z-50 pointer-events-none">
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full h-full" />

        <motion.div
          className="absolute pointer-events-none"
          style={{
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
          }}
          animate={{
            y: [0, 10, 0],
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        >
          <div className="flex flex-col items-center">
            <div className="bg-white rounded-lg p-3 mb-4 shadow-lg text-center">
              <p className="font-medium text-sm">Select a time range<br></br>to add a lesson</p>
            </div>
            <ArrowDown className="text-white w-10 h-10 drop-shadow-md" />
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default AgendaWizard;
